import { MessageSquareText } from "lucide-react";
import { Panel, EmptyState } from "@/components/admin/ui";

export const PersonFeedbackTab = () => (
  <Panel title="Feedback" subtitle="Customer feedback tied to this person's completed Jobs will appear here." testId="person-feedback-tab">
    <EmptyState
      icon={MessageSquareText}
      title="No feedback yet."
      message="Once customers can rate a completed Job, feedback for the people who performed it will show up here — nothing is invented in the meantime."
      testId="person-feedback-empty"
    />
  </Panel>
);
